import {HStack, Switch, Text} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';

interface ModeTarifaireToggleProps {
  isDerogation: boolean;
  onChange: (isDerogation: boolean) => void;
  // Cache entièrement le composant (ex: utilisateur sans permission `dero_autorisee`).
  isHidden?: boolean;
  // Désactive l'interaction sans cacher (ex: pendant la soumission de la commande).
  isDisabled?: boolean;
}

/**
 * Toggle entre prix one shot (commande seule) et dérogation (catalogue figé).
 * - Prix one shot (false) : prix valable uniquement pour cette commande
 * - Prix dérogation (true) : prix qui modifie le catalogue client avec date de fin
 *
 * `isHidden` masque complètement le composant ; `isDisabled` le grise.
 */
export const ModeTarifaireToggle: React.FC<ModeTarifaireToggleProps> = ({
  isDerogation,
  onChange,
  isHidden = false,
  isDisabled = false,
}) => {
  const {t} = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <HStack
      spacing={2}
      alignItems='center'
    >
      <Switch
        size='sm'
        isChecked={isDerogation}
        isDisabled={isDisabled}
        onChange={(e) => {
          onChange(e.target.checked);
        }}
        sx={{
          '& .chakra-switch__track': {
            bg: isDerogation ? 'blue.main' : 'gray.300',
          },
          '& .chakra-switch__thumb': {
            bg: 'white',
          },
        }}
      />
      <Text
        fontSize='xs'
        color={isDerogation ? 'blue.main' : 'gray.500'}
        whiteSpace='nowrap'
      >
        {t('back_office.prise_de_commande.panier.prix_bloque')}
      </Text>
    </HStack>
  );
};
